'use strict'

const twentyninetimes = window.twentyninetimes || {}

twentyninetimes.navigation =
  twentyninetimes.navigation ||
  (function () {
    // Helper functions for adding/removing classes with delay
    const addClassWithDelay = (
      elements,
      className,
      delay = 50,
      initialDelay = 0
    ) => {
      elements.forEach((el, i) => {
        setTimeout(
          () => {
            el.classList.add(className)
          },
          initialDelay + i * delay
        )
      })
    }

    const removeClassWithDelay = (elements, className, delay = 50) => {
      elements.forEach((el, i) => {
        setTimeout(() => {
          el.classList.remove(className)
        }, i * delay)
      })
    }

    function init() {
      const site_nav = document.getElementById('js-site-nav')
      if (site_nav) {
        siteNav(site_nav)
        sub_menu_toggle(site_nav)
        mega_menu_toggles()
      }
    }

    function mega_menu_toggles() {
      const site_header = document.getElementById('js-site-header')
      const megaMenuToggles = document.querySelectorAll('.mega-menu-toggle')
      const megaMenuGroups = document.querySelectorAll('.mega-menu-group')

      megaMenuToggles.forEach((item) => {
        item.addEventListener('click', function () {
          // Remove aria-expanded from all mega-menu-toggles except current one
          megaMenuToggles.forEach((toggle) => {
            if (toggle !== item) {
              toggle.setAttribute('aria-expanded', false)
            }
          })
          const isExpanded = item.getAttribute('aria-expanded') === 'true'
          item.setAttribute('aria-expanded', !isExpanded)

          const targetMenu = document.getElementById(item.dataset.menu)

          // Remove mega-menu-open class from all mega-menu-groups
          megaMenuGroups.forEach((group) =>
            group.classList.remove('mega-menu-open')
          )

          // Toggle the mega-menu-open class on the target menu
          if (targetMenu) {
            targetMenu.classList.toggle('mega-menu-open', !isExpanded)
          }
        })
      })

      // Close mega menu when clicking outside of it
      document.body.addEventListener('click', function (event) {
        if (!site_header.contains(event.target)) {
          megaMenuGroups.forEach((group) =>
            group.classList.remove('mega-menu-open')
          )
          megaMenuToggles.forEach((toggle) =>
            toggle.setAttribute('aria-expanded', false)
          )
        }
      })
    }

    function siteNav(site_nav) {
      const site_body = document.body
      const nav_toggle = document.getElementById('js-mobile-nav-toggle')

      const depth0 = site_nav.querySelector('.depth-0')
      // Removed unused depth1
      const parentToggles = site_nav.querySelectorAll('.menu-item-has-children')

      // Toggle sub-menu on parent items
      parentToggles.forEach((item) => {
        item.addEventListener('click', function () {
          item.classList.toggle('show-sub-menu')
        })
      })

      // Click outside nav to close
      site_body.addEventListener('click', function (event) {
        if (!site_nav.contains(event.target)) {
          nav_toggle.setAttribute('aria-expanded', false)
          site_body.classList.remove('no-scroll')
          site_body.classList.remove('nav-active')
          bodyScrollLock.enableBodyScroll(site_nav)
          parentToggles.forEach((item) =>
            item.classList.remove('show-sub-menu')
          )
        }
      })

      nav_toggle.addEventListener('click', function (event) {
        event.stopPropagation()

        const site_nav_items = site_nav.querySelectorAll(
          '.site-nav__inner > .menu > .menu-item'
        )
        const allSubOpens = site_nav.querySelectorAll('.sub-open')
        const openSubMenus = site_nav.querySelectorAll('.open-submenu')

        if (depth0 && depth0.classList.contains('depth-0-open')) {
          depth0.classList.remove('depth-0-open')
        }

        if (!site_body.classList.contains('nav-active')) {
          site_body.classList.add('nav-active')
          nav_toggle.setAttribute('aria-expanded', true)
          site_body.classList.add('no-scroll')
          bodyScrollLock.disableBodyScroll(site_nav)

          // Show nav items with a delay
          addClassWithDelay(site_nav_items, 'visible', 50, 200)
        } else {
          // Remove open classes from submenus
          allSubOpens.forEach((item) => item.classList.remove('open'))
          parentToggles.forEach((item) => {
            item.classList.remove('open')
          })
          openSubMenus.forEach((item) => item.classList.remove('open-submenu'))

          // Hide nav items with a delay
          removeClassWithDelay(site_nav_items, 'visible', 50)

          site_body.classList.remove('nav-active')
          nav_toggle.setAttribute('aria-expanded', false)
          site_body.classList.remove('no-scroll')
          bodyScrollLock.enableBodyScroll(site_nav)
        }
      })
    }

    function sub_menu_toggle(site_nav) {
      const site_nav_inner = site_nav.querySelector('.site-nav__inner')
      const sub_menu_checkboxes = site_nav_inner.querySelectorAll(
        '.sub-accordion-radio'
      )

      sub_menu_checkboxes.forEach((checkbox) => {
        // When a checkbox is clicked, uncheck all other checkboxes
        checkbox.addEventListener('click', function () {
          sub_menu_checkboxes.forEach((item) => {
            if (item !== checkbox) {
              item.checked = false
            }
          })
        })
      })

      const site_nav_items = site_nav.getElementsByClassName(
        'menu-item-has-children'
      )
      Array.from(site_nav_items).forEach((item) => {
        const sub_menu_toggle_btn = item.querySelector('.js-sub-menu-toggle')
        if (sub_menu_toggle_btn) {
          sub_menu_toggle_btn.addEventListener('click', function () {
            const nav_item = this.parentElement
            // Uncheck all sub-menu checkboxes
            sub_menu_checkboxes.forEach(
              (checkbox) => (checkbox.checked = false)
            )

            const visibles =
              document.body.querySelectorAll('.menu > .menu-item')
            const subMenuItems = nav_item.querySelectorAll(
              '.sub-menu__inner li'
            )

            if (!nav_item.classList.contains('open')) {
              nav_item.parentElement.classList.add('open-submenu')
              site_nav.classList.add('has-open-submenu')
              nav_item.classList.add('open')

              addClassWithDelay(subMenuItems, 'sub-open', 50)
              visibles.forEach((item) => {
                item.classList.remove('visible')
                if (item.classList.contains('open')) {
                  item.classList.add('visible')
                }
              })
            } else {
              removeClassWithDelay(subMenuItems, 'sub-open', 50)
              visibles.forEach((item) => item.classList.add('visible'))

              site_nav.classList.remove('has-open-submenu')
              nav_item.classList.remove('open')
              nav_item.parentElement.classList.remove('open-submenu')
            }
          })
        }
      })
    }

    return {
      init: init,
    }
  })()

// Initialize navigation if needed
// twentyninetimes.navigation.init();
